import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AdCreativesApiResponse, GenerateAdCreativeRequest, GenerateAdCreativeResult } from './types';

/**
 * Model reasoning z wejściem obrazkowym liczy dłużej niż zwykły endpoint, a
 * domyślny limit axiosa (2 min) potrafił zerwać połączenie tuż przed
 * odpowiedzią. Funkcja po stronie backendu ma 300 s.
 */
const REQUEST_TIMEOUT_MS = 280_000;

/**
 * Prosi AI o układ kreacji. Zwrotka jest już w formacie sceny edytora, więc
 * wpada wprost na planszę i można ją dalej edytować albo zapisać jako szablon.
 */
export const useGenerateAdCreative = (
  options?: UseMutationOptions<GenerateAdCreativeResult, AxiosError, GenerateAdCreativeRequest>,
): UseMutationResult<GenerateAdCreativeResult, AxiosError, GenerateAdCreativeRequest> => useMutation<
  GenerateAdCreativeResult,
  AxiosError,
  GenerateAdCreativeRequest
>({
  mutationFn: async (data) => {
    const res = await axiosInstance.post<AdCreativesApiResponse<GenerateAdCreativeResult>>(
      '/v3-generateAdCreative',
      data,
      { timeout: REQUEST_TIMEOUT_MS },
    );
    return res.data.data;
  },
  ...options,
});
